import { Modal } from '#/shared/components/Modal';

import { ForwardRequestFormOld } from './ForwardRequestForm_Old';

export interface ForwardRequestModalProps {
  isOpen: boolean;
  onClose: () => void;
}

// TODO: PPL-2239-timesheet-actions-selection cleanup - Delete this component
export function ForwardRequestModal({ isOpen, onClose }: Readonly<ForwardRequestModalProps>) {
  return (
    <Modal isOpen={isOpen}>
      <ForwardRequestFormOld onModalClose={onClose} />
    </Modal>
  );
}
